import { render, staticRenderFns } from "./Break.vue?vue&type=template&id=3a6780c6&"
import script from "./Break.vue?vue&type=script&lang=js&"
export * from "./Break.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports